module.exports = __webpack_public_path__ + "img/bands.df6f3fe6.jpg";